// extracted by mini-css-extract-plugin
export var cardSelected = "_eq-2";
export var image = "_eq-1";
export var table = "_eq-0";